import { Navigate, useParams } from "react-router-dom";
import { useListEnrollments } from "@/api/generated/enrollments/enrollments";
import { LoadingState } from "@/components/common/LoadingState";
import { ErrorState } from "@/components/common/ErrorState";
import { DashboardPage } from "@/pages/DashboardPage";

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const ERROR_TEXTS = {
  loadFailed: { title: "Dashboard konnte nicht geladen werden" },
  notEnrolled: {
    title: "Kein Zugang zu diesem Kurstermin",
    message: "Du bist für diesen Kurstermin nicht eingeschrieben.",
  },
};

// Non-UUID keys are schedule external IDs: one shared link per course date.
export const DashboardGateway = () => {
  const { enrollmentId: key = "" } = useParams<{ enrollmentId: string }>();
  const isScheduleLink = !UUID_PATTERN.test(key);
  // The signed-in user's enrollment in the schedule; empty when not enrolled.
  const { data, error, isLoading } = useListEnrollments<Error>(
    { schedule_external_id: key },
    { swr: { enabled: isScheduleLink } }
  );
  const enrollment = data?.[0];

  if (!isScheduleLink) return <DashboardPage />;
  if (isLoading) return <LoadingState message="Dashboard wird geladen..." />;
  if (error || !enrollment)
    return (
      <ErrorState
        message={error?.message}
        {...ERROR_TEXTS[error ? "loadFailed" : "notEnrolled"]}
      />
    );
  return <Navigate to={`/course/${enrollment.id}/dashboard`} replace />;
};
